import { gql } from "@apollo/client";

const MeetingViewMeetingGroupNewPageFragment = gql`
  fragment MeetingViewMeetingGroupNewPageFragment on MeetingGroupNode {
    id
    title
    hasTemplate
    allowAdminVisibility
    allowOrgVisibility
    allowManagementTreeVisibility
    isFormalOneonone
    canUpdate {
      permission
    }
    facilitator {
      id
      name
      avatar
    }
    organization {
      id
      name
    }
    syncCredentials {
      id
      hasCalendarWriteCredentials
      provider
    }
    topicTemplate {
      id
      title
      organization {
        id
      }
      globalTemplate
      publicTemplate
      meetingTemplate
      finalizePermissions
    }
    # MEETING BOT
    meetingBotSetting
    addTranscriptionBotToMeetingsByDefault
    transcribeMeetingsByDefault
  }
`;

export default MeetingViewMeetingGroupNewPageFragment;
